import { render, staticRenderFns } from "./TileItem.vue?vue&type=template&id=1d54f246&scoped=true"
import script from "./TileItem.vue?vue&type=script&lang=js"
export * from "./TileItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d54f246",
  null
  
)

export default component.exports